"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.basketLocationToAddress = void 0;
const ts_pattern_1 = require("ts-pattern");
const basketLocationToAddress = (location) => (0, ts_pattern_1.match)(location)
    .with({ __typename: 'Address' }, (a) => a)
    .with({ __typename: 'NewAccountLocation' }, ({ address }) => address)
    .with({ __typename: 'AccountLocation' }, ({ address }) => address)
    .with({ __typename: undefined }, () => ({
    flatOrBuilding: '',
    floorOrBuildingName: '',
    street: '',
    postcode: '',
    city: '',
    country: '',
    latitude: null,
    longitude: null,
}))
    .exhaustive();
exports.basketLocationToAddress = basketLocationToAddress;
